import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { group } from './ButtonGroup.tokens.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children", "vertical"];
var border = group.border;
var radius = border.radius;
var ButtonGroupBase = styled.div.withConfig({
  displayName: "ButtonGroup__ButtonGroupBase",
  componentId: "sc-1fn8jon-0"
})(["display:inline-flex;> *{border-radius:0;@media (hover:hover) and (pointer:fine){&:hover{border-radius:0;}}}", ""], function (_ref) {
  var $vertical = _ref.$vertical;
  return $vertical ? css(["flex-direction:column;> :first-child{border-top-left-radius:", ";border-top-right-radius:", ";}> :last-child{border-bottom-left-radius:", ";border-bottom-right-radius:", ";}> :not(:last-child){border-bottom:none;}"], radius, radius, radius, radius) : css(["> :first-child{border-top-left-radius:", ";border-bottom-left-radius:", ";}> :last-child{border-top-right-radius:", ";border-bottom-right-radius:", ";}> :not(:last-child){border-right:none;}"], radius, radius, radius, radius);
});
var ButtonGroup = /*#__PURE__*/forwardRef(function ButtonGroup(_ref2, ref) {
  var children = _ref2.children,
    vertical = _ref2.vertical,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var props = _objectSpread({
    ref: ref,
    $vertical: vertical
  }, rest);
  return /*#__PURE__*/jsx(ButtonGroupBase, _objectSpread(_objectSpread({
    role: "group"
  }, props), {}, {
    children: children
  }));
});

export { ButtonGroup };
